import { observable } from "mobx";
import { Type } from "class-transformer";
import KafkaDltMessageType from "./kafkaDltMessageType";
import KafkaDltTopic from "./kafkaDltTopic";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class DeadLetterTopicMessageResponse {
  id!: string;

  @observable
  @Type(() => Date)
  originalProducedAt!: Date;

  @observable
  messageType!: KafkaDltMessageType;

  @observable
  topic!: KafkaDltTopic;

  @observable
  deliveryAttempts!: number;
}

export default class DeadLetterTopicMessage extends DeadLetterTopicMessageResponse {
  @observable
  isSelectable: boolean = true;
}
